import { Footer } from 'remote-com-shared/components/Footer';
import HeroContext, { useHeroIntersection } from 'remote-com-shared/components/Hero/context';

import { Banner } from '@/src/components/Banner/Banner';
import { hasBanner } from '@/src/components/Banner/helpers';
import { transformProperties } from '@/src/domains/prismic/helpers';

export const SinglePageScrollLayout = ({ sharedServices, children }) => {
  const heroIntersection = useHeroIntersection();
  const { bannerSitewide, footerNavigationSitewide } = sharedServices ?? {};
  const bannerProps = transformProperties(bannerSitewide);
  const { description } = bannerProps ?? {};

  return (
    <HeroContext.Provider value={heroIntersection}>
      {hasBanner(description) ? <Banner {...bannerProps} /> : null}
      {children}
      <Footer {...footerNavigationSitewide} />
    </HeroContext.Provider>
  );
};
